import "./YourJourney.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TheExperience from "./sections/TheExperience";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import PatientResources from "./sections/PatientResources";
import Footer from "@/reusable_sections/Footer";
export default function YourJourneyPage() {
  return <div>
      <MainNavigation />
      <TheExperience />
      <FrequentlyAskedQuestions />
      <PatientResources />
      <Footer />
    </div>;
}